export namespace DateUtils {
    export function DaysAgo(startDate: Date, endDate: Date): number {
        const oneDay = 1000 * 60 * 60 * 24;
        // A day in UTC always lasts 24 hours (unlike in other time formats)
        const start = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const end = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
        // so it's safe to divide by 24 hours
        return Math.ceil((end - start) / oneDay);
    }

    export function GetMidnight(): Date {
        const midnight = new Date();
        midnight.setHours(23, 59, 59, 0);
        return midnight;
    }

    export function GetNextMidnight(date: Date): Date {
        date.setDate(date.getDate() + 1)
        date.setHours(23, 59, 59, 0);
        return date;
    }
}
